// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import i18n from 'vue-i18n'
import Resource from 'vue-resource'
import browser from 'detect-browser'
import ElementUI from 'element-ui'
import Vuelidate from 'vuelidate'

import store from './store/index'
import {
  USER,
  INIT_STATE
  // IS_APP_LOADING
} from './store/definition'

import { initialize } from 'src/components/common/store/definition'

import routes from './routes'
import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue)

const LoginView = resolve => require(['./components/auth/Login'], resolve)
const LoginView2 = resolve => require(['./components/auth/Login2'], resolve)
const HomeView = resolve => require(['./components/Main'], resolve)

// const TablesView = resolve => require(['./components/demo/Tables'], resolve)
// const BookingView = resolve => require(['./components/booking/Booking'], resolve)
const LabView = resolve => require(['./components/demo/Lab'], resolve)
const Datatable2 = resolve => require(['./components/demo/datatable2/Datatable2'], resolve)

const Timeout = resolve => require(['./components/error/Timeout'], resolve)

const locales = {
  en: require('./assets/i18n/en.js').default
}
const BrowserNotSupport = resolve => require(['./components/error/BrowserNotSupport'], resolve)

// import sourcingWorkflowRoutes from './components/sourcing_workflow/routes'
// import pclRoutes from './components/pclroutes'
// import bookingRoutes from './components/bookingRoutes'
// import rptRoutes from './components/rptRoutes'
// import rptRoutesNew from './components/rptRoutes_new'
// import pclRoutesNew from './components/pclroutes_new'

/* eslint-disable no-new */
Vue.use(Router)
Vue.use(i18n)
Vue.use(Resource)
Vue.use(ElementUI)
Vue.use(Vuelidate)

Vue.config.lang = 'en'

Object.keys(locales).forEach(function (lang) {
  Vue.locale(lang, locales[lang])
})

const router = new Router({
  // mode: 'history',
  // base: '/smee/',
  routes: [
    {path: '/login', component: LoginView},
    {path: '/lab', component: LabView},
    {path: '/datatable2', component: Datatable2},
    {path: '/login2', component: LoginView2},
    {path: '/browser-not-support', component: BrowserNotSupport},
    {path: '/timeout', component: Timeout},
    {
      path: '/',
      component: HomeView,
      // children: [
      //   {path: '/tables', component: TablesView},
      //   {path: '/booking', component: BookingView},
      //   ...sourcingWorkflowRoutes,
      //   ...pclRoutes,
      //   ...bookingRoutes,
      //   ...rptRoutes,
      //   ...rptRoutesNew,
      //   ...pclRoutesNew
      // ]
      children: [
        ...routes
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (browser.name !== 'chrome' && to.path !== '/browser-not-support') {
    next({ path: '/browser-not-support' })
    return
  }

  const publicPaths = ['/browser-not-support', '/login', '/timeout']
  if (publicPaths.includes(to.path)) {
    next()
    return
  }

  if (store.getters[USER] !== null) {
    next()
    return
  }

  // Store intended destination, then check /user-details for an active session.
  // If session is valid  → user is returned, Vuex store populated, navigation continues.
  // If 401 (no session) → redirect browser to Spring Security's OAuth2 authorization
  //                        endpoint which initiates the Ping Identity OIDC login flow.
  //                        After login, Ping redirects back to the gateway callback,
  //                        OidcAuthenticationSuccessHandler restores the original page
  //                        from the session 'page' attribute set by /toPath.
  // vue-resource does NOT reject on 4xx responses — they resolve with response.ok === false.
  // So both the success case (200 with user) and failure case (401 no session) arrive in .then().
  // We must check response.ok explicitly; relying on .catch() alone misses 401 responses.

  Vue.http.get('/smee/user-details')
    .then(response => {
      if (response.ok && response.body && response.body.user) {
        // Valid session — dispatch INIT_STATE which:
        //   1. Commits SET_USER
        //   2. Registers all Vuex modules (sourcingWorkflow, common, qas, samplemanagement, bookingStore)
        //   3. Calls preInit to fetch initial data
        // Then navigate to /landing-page — same behaviour as the old Sso.vue flow.
        store.dispatch(INIT_STATE, {
          user: response.body.user,
          store
        }).then(() => {
          return store.dispatch(initialize)
        }).then(() => {
          next({ path: '/landing-page' })
        }).catch(() => {
          next({ path: '/landing-page' })
        })
      } else if (response.status === 403) {
        // 403 = authenticated via Ping Identity OIDC but account not provisioned in USER_MASTER_T.
        // OidcAuthenticationSuccessHandler catches this before the Vue app loads, but guard here
        // too.  Hard-navigate to the gateway's HTML error page so Vue Router / cached bundles
        // are bypassed and the Kerberos loop cannot start.
        window.location.href = '/smee/access-denied'
      } else {
        // 401 (or unexpected error) — no active OIDC session.
        // Redirect to Spring Security OIDC endpoint to initiate Ping Identity login.
        window.location.href = '/smee/oauth2/authorization/pingidentity'
      }
    })
    .catch(() => {
      // Network error or other failure
      window.location.href = '/smee/oauth2/authorization/pingidentity'
    })
})

// const pathsShouldShowLoadingIndicatior = ['/sourcing-wf/responsive-management/review-nomination']

// router.afterEach((to, from) => {
//   if (pathsShouldShowLoadingIndicatior.indexOf(to.path) !== -1) {
//     store.commit(IS_APP_LOADING, true)
//   }
// })

new Vue({
  router,
  store
}).$mount('#app')

Vue.http.interceptors.push(function (request, next) {
  if (request.url.indexOf('/sms') >= 0 || request.url.indexOf('/fabrictracker') >= 0) {
    request.headers.set('SMEEToken', request.headers.get('Authorization').substring(7))
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js